import { RugbyLeagueEventStatusId } from '@collector/sportsapi-client-legacy'

import { PitchBlockedEventStatus } from '../../../configuration'

export default null

export const pitchBlockedEventStatus: PitchBlockedEventStatus<RugbyLeagueEventStatusId> =
  new Set([
    RugbyLeagueEventStatusId.Abandoned,
    RugbyLeagueEventStatusId.Cancelled,
    RugbyLeagueEventStatusId.NotStarted,
    RugbyLeagueEventStatusId.StartDelayed,
    RugbyLeagueEventStatusId.Postponed,
    RugbyLeagueEventStatusId.Interrupted,
    RugbyLeagueEventStatusId.ToFinish,
    RugbyLeagueEventStatusId.FinishedAwardedWin,
    RugbyLeagueEventStatusId.FinishedRegularTime,
    RugbyLeagueEventStatusId.FinishedAfterExtratime,
    RugbyLeagueEventStatusId.FinishedAfterPenalties,
    RugbyLeagueEventStatusId.Halftime,
    RugbyLeagueEventStatusId.ExtratimeHalftime,
    RugbyLeagueEventStatusId.WaitingForExtratime,
    RugbyLeagueEventStatusId.WaitingForPenalty,
    RugbyLeagueEventStatusId.Penalties,
  ])
